var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-page-not-found-search" },
    [
      _c("div", { staticClass: "vuestic-page-not-found-search__content" }, [
        _c(
          "div",
          { staticClass: "vuestic-page-not-found-search__wallpaper" },
          [
            _c("router-link", {
              staticClass: "i-vuestic vuestic-page-not-found-search__i-vuestic",
              attrs: { to: { path: "/" } },
            }),
          ],
          1
        ),
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "vuestic-page-not-found-search__wallpaper" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              {
                staticClass: "input-group vuestic-page-not-found-search__input",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputValue,
                      expression: "inputValue",
                    },
                  ],
                  staticStyle: { color: "white" },
                  attrs: { placeholder: "Search on the menu" },
                  domProps: { value: _vm.inputValue },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.inputValue = $event.target.value
                    },
                  },
                }),
                _c("i", { staticClass: "bar", style: "width: " + 310 + "px" }),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass:
              "vuestic-page-not-found-search__wallpaper vuestic-page-not-found-search__not-found-wallpaper-list",
          },
          [
            _c(
              "div",
              { staticClass: "vuestic-page-not-found-search__wrapper" },
              _vm._l(_vm.filterItems, function (category, index) {
                return _c(
                  "ul",
                  {
                    key: index,
                    staticClass: "vuestic-page-not-found-search__list",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(category.categoryName) +
                        "\n          "
                    ),
                    _vm._l(category.items, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass:
                            "vuestic-page-not-found-search__list-element",
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { path: item.itemLink } } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.itemName) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
      ]),
      _c("vuestic-page-not-found-sad-wallpaper"),
      _c("made-by-component"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "vuestic-page-not-found-search__wallpaper" },
      [
        _c("h3", { staticClass: "vuestic-page-not-found-search__text" }, [
          _vm._v("The page's gone\n        fishing."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "vuestic-page-not-found-search__wallpaper flex md12" },
      [
        _c(
          "div",
          { staticClass: "va-row vuestic-page-not-found-search__message" },
          [
            _c(
              "h4",
              { staticClass: "vuestic-page-not-found-search__text-small" },
              [
                _vm._v(
                  "\n          If you feel that it's not right, please send us a message at  \n        "
                ),
              ]
            ),
            _c("a", { attrs: { href: "mailto:hello@epicmax.co" } }, [
              _vm._v("hello@epicmax.co"),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }